import { svg } from "lit";
/** Wedding event icon — rings (24x24, fill=currentColor) */
export const weddingIcon = svg `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M9 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/>
    <path d="M15 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/>
    <path d="M9 13a6 6 0 0 0-6 6v1a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-1a6 6 0 0 0-6-6H9Zm-4 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v1H5v-1Z"/>
  </svg>`;
//# sourceMappingURL=wedding.js.map